module.exports = __webpack_public_path__ + "static/img/moment.c6124d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/moment.png
// module id = QSq/
// module chunks = 0